import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

interface BirthdayPosterProps {
    name: string;
    profileUrl?: string;
    onDownloadComplete?: () => void;
}

const BirthdayPoster: React.FC<BirthdayPosterProps> = ({ name, profileUrl, onDownloadComplete }) => {
    const posterRef = useRef<HTMLDivElement>(null);

    const handleDownload = async () => {
        if (!posterRef.current) return;
        const canvas = await html2canvas(posterRef.current, { useCORS: true });
        const dataUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.download = `Birthday_Poster_${name.replace(/\s+/g, '_')}.png`;
        link.href = dataUrl;
        link.click();
        if (onDownloadComplete) onDownloadComplete();
    };

    return (
        <div className="flex flex-col items-center p-4">
            <h2 className="text-xl font-bold mb-4 text-gray-800">Your Birthday Poster</h2>
            <div 
                ref={posterRef} 
                className="relative w-[400px] h-[500px] bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-xl shadow-2xl flex flex-col items-center justify-center overflow-hidden"
                style={{ padding: '20px', textAlign: 'center' }}
            >
                {/* Decorative Elements */}
                <div className="absolute top-0 left-0 w-full h-full opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                <div className="absolute top-4 left-4 text-4xl">🎈</div>
                <div className="absolute top-4 right-4 text-4xl">🎉</div>
                <div className="absolute bottom-4 left-4 text-4xl">🎁</div>
                <div className="absolute bottom-4 right-4 text-4xl">🎂</div>

                {/* Profile Image */}
                <div className="z-10 w-32 h-32 rounded-full border-4 border-white overflow-hidden shadow-lg mb-6 bg-white flex items-center justify-center">
                    {profileUrl ? (
                        <img src={profileUrl} alt={name} className="w-full h-full object-cover" crossOrigin="anonymous" />
                    ) : (
                        <span className="text-4xl text-gray-400">👤</span>
                    )}
                </div>

                {/* Greeting */}
                <h1 className="z-10 text-4xl font-extrabold text-white mb-2 drop-shadow-md">
                    Happy Birthday!
                </h1>
                <h2 className="z-10 text-2xl font-bold text-yellow-300 drop-shadow-md">
                    {name}
                </h2>
                
                <p className="z-10 mt-6 text-white font-medium text-lg drop-shadow-sm max-w-[80%]">
                    Wishing you a fantastic day and a wonderful year ahead from RMB Jaipur!
                </p>
            </div>
            <button 
                onClick={handleDownload} 
                className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-full font-bold shadow-lg hover:bg-blue-700 transition"
            >
                Download Poster
            </button>
        </div>
    );
};

export default BirthdayPoster;
